<template>
  <v-col class="pb-0">
    <v-autocomplete
      chips
      small-chips
      :items="operation_levels_order"
      :loading="$apollo.loading"
      item-value="uuid"
      item-text="name"
      outlined
      label="Driftnivå"
      v-model="operation_level_uuid"
      :disabled="disabled"
      persistent-hint
    >
      <template v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          small
          :color="operationLevelColor(data.item.name)"
          @click="data.select"
        >
          {{ data.item.name }}
        </v-chip>
      </template>
    </v-autocomplete>
  </v-col>
</template>

<script>
import { sync } from 'vuex-pathify'
import gql from 'graphql-tag'
import { required } from '@/common/validationRules'
import operationLevelColor from '@/common/operationLevelColor'

export default {
  name: 'EventOperationLevelField',

  props: {
    disabled: Boolean
  },

  data: () => ({
    required
  }),

  computed: {
    operation_level_uuid: sync('event/model@operation_level_uuid'),

    operation_levels_order() {
      const operation_levels = this.operation_levels || []
      if (!operation_levels.length) return []
      return ['Röd', 'Orange', 'Gul'].map(x =>
        operation_levels.find(({ name }) => x === name)
      )
    }
  },

  apollo: {
    operation_levels: {
      query: gql`
        query operationLevels {
          operation_levels {
            uuid
            name
          }
        }
      `
    }
  },

  methods: {
    operationLevelColor
  }
}
</script>
